export const lightGroupsConfig = {
  subsolo01: [
    {
      id: "grupo48",
      modulo: "6",
      idx: "8",
      descricao: "Circuito 48",
      lightType: "normal",
      instances: [
        { x: 87.6, y: 47.9, width: 3.5, height: 5.1, circleNumber: 48 },
        { x: 65.2, y: 55.5, width: 3.5, height: 5.1, circleNumber: 48 },
        { x: 60.7, y: 41.2, width: 3.5, height: 5.1, circleNumber: 48 },
        { x: 25.2, y: 76.2, width: 3.5, height: 5.1, circleNumber: 48 }
      ]
    }
  ],
  subsolo02: [
    {
      id: "grupo49",
      modulo: "7",
      idx: "1",
      descricao: "Circuito 49",
      lightType: "normal",
      instances: [
        { x: 87.6, y: 47.9, width: 3.5, height: 5.1, circleNumber: 49 },
        { x: 65.2, y: 55.5, width: 3.5, height: 5.1, circleNumber: 49 },
        { x: 60.7, y: 41.2, width: 3.5, height: 5.1, circleNumber: 49 },
        { x: 25.2, y: 76.2, width: 3.5, height: 5.1, circleNumber: 49 }
      ]
    }
  ],
  subsolo03: [
    {
      id: "grupo50",
      modulo: "7",
      idx: "2",
      descricao: "Circuito 50",
      lightType: "normal",
      instances: [
        { x: 87.6, y: 47.9, width: 3.5, height: 5.1, circleNumber: 50 },
        { x: 65.2, y: 55.5, width: 3.5, height: 5.1, circleNumber: 50 },
        { x: 60.7, y: 41.2, width: 3.5, height: 5.1, circleNumber: 50 },
        { x: 25.2, y: 76.2, width: 3.5, height: 5.1, circleNumber: 50 }
      ]
    }
  ]
};